import * as React from 'react';
import Button from '@mui/material/Button';
import { lightBlue } from '@mui/material/colors';

export default function NextButton(props) {
  return (
      <Button variant="contained" sx={{ bgcolor: lightBlue[500] }} disabled={props.isDisabled} style={{ color: 'white'}} {...props}>{props.title != undefined ? props.title : "Next"}</Button>
  );
}
